import { render, staticRenderFns } from "./ProjectEditModal.vue?vue&type=template&id=35544ae0&"
import script from "./ProjectEditModal.vue?vue&type=script&lang=js&"
export * from "./ProjectEditModal.vue?vue&type=script&lang=js&"
import style0 from "./ProjectEditModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormInput: require('/workspace/components/Form/FormInput.vue').default,FormGroup: require('/workspace/components/Form/FormGroup.vue').default})
